export const GET_SHIPMENTS_REQUEST = 'GET_SHIPMENTS_REQUEST';
export const requestGetShipments = () => {
  return {
    type: GET_SHIPMENTS_REQUEST,
  };
};
export const requestViewShipments = (viewId) => {
  return {
    type: GET_SHIPMENTS_REQUEST,
    viewId,
  };
};

export const GET_SHIPMENTS_SUCCESS = 'GET_SHIPMENTS_SUCCESS';
export const getShipmentsSuccess = (shipments, page, pageSize, totalCount, currentPageFulfillmentIds) => {
  return {
    type: GET_SHIPMENTS_SUCCESS,
    page,
    pageSize,
    totalCount,
    currentPageFulfillmentIds,
  };
};

export const GET_SHIPMENTS_FAILURE = 'GET_SHIPMENTS_FAILURE';
export const getShipmentsFailure = (error) => {
  return {
    type: GET_SHIPMENTS_FAILURE,
    ...error,
  };
};

export const GET_SILENT_SHIPMENTS_REQUEST = 'GET_SILENT_SHIPMENTS_REQUEST';
export const silentRequestGetShipments = () => ({
  type: GET_SILENT_SHIPMENTS_REQUEST,
});

export const ASSIGN_BULK_FULFILLMENT_PLAN_TO_USER = 'ASSIGN_BULK_FULFILLMENT_PLAN_TO_USER';
export const assignBulkFulfillmentPlanToUser = (fulfillmentPlanIds, userId) => {
  return {
    type: ASSIGN_BULK_FULFILLMENT_PLAN_TO_USER,
    fulfillmentPlanIds,
    userId,
  };
};

export const SCHEDULE_USPS_PICKUP = 'SCHEDULE_USPS_PICKUP';
export const scheduleUspsPickup = (payload) => ({
  type: SCHEDULE_USPS_PICKUP,
  payload,
});

export const CANCEL_USPS_PICKUP = 'CANCEL_USPS_PICKUP';
export const cancelUspsPickup = (payload) => ({
  type: CANCEL_USPS_PICKUP,
  payload,
});
